
export function removeDuplicates(arr, key): any[] {

  return [...new Map(arr.map(item => [item[key], item])).values()];
}

export function removeDuplicatesSimpleArray(arr) {

  return [...new Set(arr)];
}

export function hasAdvancedOptions(tweet: any): [boolean, any?] {
  const threadTweets = tweet.text.split("\n\n\n");

  let nbReminders = 0;
  let isPreventLinkExpand = false;
  let isAutoRetweet = false;
  let isAutoPlug = false;
  let isDelayBetweenTweets = false;
  let isAutoDm = false;
  let dmString = "";
  let isAutoRtWithOtherAccounts = false;
  let isLiveTweet = false;

  if (tweet?.isPreventLinkExpand && tweet.text.includes("http")) {
    isPreventLinkExpand = true;
    nbReminders++;
  }
  if (tweet?.isAutoRetweet) {
    isAutoRetweet = true;
    nbReminders++;
  }
  if (tweet?.isAutoPlug) {
    isAutoPlug = true;
    nbReminders++;
  }
  if (tweet?.isDelayBetweenTweets && threadTweets.length > 1) {
    isDelayBetweenTweets = true;
    nbReminders++;
  }
  if (tweet?.isAutoDm) {
    isAutoDm = true;
    nbReminders++;
    let triggers = [] as any;
    if (tweet?.autoDmTrigger?.retweet) triggers.push("retweet");
    if (tweet?.autoDmTrigger?.reply) triggers.push("reply");
    if (tweet?.autoDmTrigger?.like) triggers.push("like");
    dmString = triggers.join(" and ");
  }
  if (tweet?.autoRtWithOtherAccounts) {
    isAutoRtWithOtherAccounts = true;
    nbReminders++;
  }
  if (tweet?.isLiveTweet) {
    isLiveTweet = true;
    nbReminders++;
  }

  if (nbReminders > 0) {
    return [
      true,
      {
        isPreventLinkExpand,
        isAutoRetweet,
        isAutoPlug,
        isDelayBetweenTweets,
        isAutoDm,
        isAutoRtWithOtherAccounts,
        isLiveTweet,
      },
    ];
  }

  return [false];
}

export function removeMarkdown(text: string) {
  // Bold and strong
  text = text.replace(/(\*\*|__)(.*?)\1/gm, '$2');

  // Italics and emphasis
  text = text.replace(/(\*|_)(.*?)\1/gm, '$2');

  // Strikethrough
  text = text.replace(/~~(.*?)~~/gm, '$1');

  // Code blocks and inline code
  text = text.replace(/`{1,2}([^`]+)`{1,2}/gm, '$1');

  // Links
  text = text.replace(/\[([^\]]+)\]\([^)]+\)/gm, '$1');

  // Images
  text = text.replace(/!\[([^\]]*)\]\([^)]+\)/gm, '$1');

  // Blockquotes
  text = text.replace(/^\s*>+\s?/gm, '');

  // Headings
  text = text.replace(/^\s*#{1,6}\s+/gm, '');

  // Horizontal rules
  text = text.replace(/^\s*([-*_]){3,}\s*$/gm, '');

  // Lists
  text = text.replace(/^\s*[\*\-\+]\s+/gm, '');
  text = text.replace(/^\s*\d+\.\s+/gm, '');

  // Remove any remaining markdown syntax
  text = text.replace(/(\*|_|\~|\`|\>|\-|\+|\#)/gm, '');


  return text;
}

export function addNewLineThree(text: string) {

  // Replace each full stop, exclamation mark, and question mark followed by a space or end of line with itself and a newlinetext.replace(/([.!?])(\s+|$)/g, "$1\n\n");
  // /([.!?])(\s+|$)(?!(?:\s*\d+\.\s|\s*\w+))/g
  return text.replaceAll(/([.!?])(\s+|$)(?!(?:\s*\d+\.\s|\s*\w+))/g, '$1' + `\n\n`);
  // (\?)|(\.)|(\!)(?!\s*\n\s*\n)(?!\s*\d+\.)
}

export function removeHashtagsAndEmojis(text: string) {
  // Regular expression to match hashtags
  const hashtagRegex = /#[\w-]+/g;

  // Regular expression to match emojis (unicode range for emojis)
  //@ts-ignore
  const emojiRegex = /[\u{1F600}-\u{1F6FF}\u{1F300}-\u{1F5FF}\u{1F900}-\u{1F9FF}\u{1F1E6}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;

  // Remove hashtags and emojis
  return text.replace(hashtagRegex, '').replace(emojiRegex, '');
};